import { createFileRoute, notFound, redirect } from "@tanstack/react-router";

import { BestPage } from "../components/best/BestPage";
import { bestHead } from "../lib/best/head";
import { bestPath, bestSlugOf, loadBestCopy } from "../lib/best/index";
import { BEST_UI } from "../lib/best/ui";
import { siteLangOf } from "../lib/marketing/registry";
import { documentHeaders } from "../lib/seo";

/** `/<lang>/best/<slug>`. Same 301 rule as every other localized route. */
export const Route = createFileRoute("/$lang/best/$slug")({
  loader: async ({ params }) => {
    const lang = siteLangOf(params.lang);
    if (!lang) throw notFound();
    const slug = bestSlugOf(params.slug);
    if (!slug) throw notFound();

    const path = bestPath(slug, lang);
    if (path !== `/${params.lang}/best/${params.slug}`)
      throw redirect({ href: path, statusCode: 301 });

    return { lang, slug, copy: await loadBestCopy(lang) };
  },
  headers: documentHeaders,
  head: ({ loaderData }) =>
    loaderData
      ? bestHead(
          loaderData.slug,
          loaderData.lang,
          loaderData.copy[loaderData.slug],
          BEST_UI[loaderData.lang],
        )
      : {},
  component: LocalizedBest,
});

function LocalizedBest() {
  const { lang, slug, copy } = Route.useLoaderData();
  return (
    <BestPage
      slug={slug}
      copy={copy[slug]}
      ui={BEST_UI[lang]}
      lang={lang}
      allCopy={copy}
    />
  );
}
